import React from 'react'
import Button from '../Button/Button'

export const OverviewCards = (props) => {
  const {
    sectionId,
    heading,
    copy,
    cards,
    fullHeightImages = false,
  } = props
  const headingId = sectionId ? `${sectionId}-heading` : undefined

  return (
    <section id={sectionId} className="section" aria-labelledby={headingId}>
      <div>
        <div className="section-heading">
          <h2 id={headingId}>{heading}</h2>
        </div>
        {copy && copy.map((paragraph, key) => (
          <p key={`overviewHeadingParagraph${key}`}>{paragraph}</p>
        ))}
        <div className="cards">
          {cards.map((cardConfig, key) => (
            <article key={`overviewCardArticle${key}`} className='card'>
              {fullHeightImages ? (
                <div className='card__image-frame'>
                  <img
                    src={cardConfig.imgSrc}
                    alt={cardConfig.heading}
                    className={`card__image${cardConfig.imageFit === 'cover' ? ' card__image--cover' : ''}`}
                    style={cardConfig.imageObjectPosition ? { objectPosition: cardConfig.imageObjectPosition } : undefined}
                  />
                </div>
              ) : (
                <div
                  style={{
                    backgroundImage: `url(${cardConfig.imgSrc})`,
                    backgroundPosition: `${cardConfig.imgXBackgroundPosition} ${cardConfig.imgYBackgroundPosition}`,
                  }}
                  className="card__picture"
                  role="img"
                  aria-label={cardConfig.heading}
                />
              )}
              <div className='card-content'>
                <div className='card-header'>
                  <h3>{cardConfig.heading}</h3>
                </div>
                {cardConfig.copy && cardConfig.copy.map((cardParagraph, key) => (
                  <p key={`overviewCardParagraph${key}`}>{cardParagraph}</p>
                ))}
              </div>

              <div className='card-buttons'>
                {cardConfig.links && cardConfig.links.map((link, key) => (
                  <Button key={`overViewCardButton${key}`} {...link} />
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OverviewCards